import ModalTradingDuration from "./modal-trading-duration";

export default ModalTradingDuration